import {UsersType} from '@/types/auth'
import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'

const mock = new MockAdapter(axios)

export const fakeUsers: UsersType[] = [
    {
        id: '1',
        email: 'user@demo.com',
        username: 'demo_user',
        password: '123456',
        firstName: 'Demo',
        lastName: 'User',
        role: 'User',
        token:
            'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJ0ZWNoemFhIiwiYXVkIjoiaHR0cHM6Ly90ZWNoemFhLmdldGFwcHVpLmNvbS8iLCJzdWIiOiJzdXBwb3J0QGNvZGVydGhlbWVzLmNvbSIsImxhc3ROYW1lIjoiVGVjaHphYSIsIkVtYWlsIjoidGVjaHphYXN0dWRpb0BnbWFpbC5jb20iLCJSb2xlIjoiQWRtaW4iLCJmaXJzdE5hbWUiOiJUZXN0VG9rZW4ifQ.ud4LnFZ-mqhHEYiPf2wCLM7KvLGoAxhXTBSymRIZEFLleFkO119AXd8p3OfPCpdUWSyeZl8-pZyElANc_KHj5w',
    },
    {
        id: '2',
        email: 'user@demo.com',
        username: 'demo_admin',
        password: '123456',
        firstName: 'Admin',
        lastName: 'User',
        role: 'Admin',
        token:
            'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJ0ZWNoemFhIiwiYXVkIjoiaHR0cHM6Ly90ZWNoemFhLmdldGFwcHVpLmNvbS8iLCJzdWIiOiJzdXBwb3J0QGNvZGVydGhlbWVzLmNvbSIsImxhc3ROYW1lIjoiVGVjaHphYSIsIkVtYWlsIjoidGVjaHphYXN0dWRpb0BnbWFpbC5jb20iLCJSb2xlIjoiQWRtaW4iLCJmaXJzdE5hbWUiOiJUZXN0VG9rZW4ifQ.ud4LnFZ-mqhHEYiPf2wCLM7KvLGoAxhXTBSymRIZEFLleFkO119AXd8p3OfPCpdUWSyeZl8-pZyElANc_KHj5w',
    },
]

export default function configureFakeBackend() {
    mock.onPost('/login').reply(function (config) {
         
        return new Promise(function (resolve, _reject) {
            setTimeout(function () {
                // get parameters from post request
                const params = JSON.parse(config.data)
                // find if any user matches login credentials
                const filteredUsers = fakeUsers.filter((user) => {
                    return user.email === params.email && user.password === params.password
                })

                if (filteredUsers.length) {
                    // if login details are valid return user details and fake jwt token
                    const user = filteredUsers[0]
                    resolve([200, user])
                } else {
                    // else return error
                    resolve([401, {error: 'Email or password is incorrect'}])
                }
            }, 1000)
        })
    })
}